<template>
  <div class="shopping-cart-section">
    <div class="left">
      <h4 class="heading">
        Course
      </h4>
      <div class="in-cart-list" v-if="getCart.length !== 0">
        <div
          v-for="course in getCart"
          :key="course.course_id"
          class="cart-item"
        >
          <div class="cover">
            <img :src="course.image_url" />
          </div>
          <div class="title" @click="goToDescription(course.course_id)">
            <p>{{ course.course_name }}</p>
          </div>
          <div class="remove" @click="removeFromCart(course.course_id)">
            <!--<font-awesome-icon icon="trash-alt" size="lg"></font-awesome-icon>-->
            <img src="/img/icons/png/trash.png" alt="" />
          </div>
          <div class="price">
            <span class="current">₹{{ course.price }}</span>
            <!--<span class="discount">$4500</span>-->
          </div>
        </div>
      </div>
      <div style="text-align: center" v-else>
        <img style="width: 100%" src="/img/emptycart.png" />
        <b-button size="md" pill variant="primary" @click="goToHome">
          <span>Continue </span>
        </b-button>
      </div>
      <!--<hr />-->
      <!--<h4 class="heading mt-5">-->
      <!--Recently Wishlist-->
      <!--</h4>-->
      <!--<div class="in-cart-list">-->
      <!--<div-->
      <!--v-for="course in getWishlist"-->
      <!--:key="course.course_id"-->
      <!--class="cart-item"-->
      <!--&gt;-->
      <!--<div class="cover">-->
      <!--<img :src="course.course_properties.imgUrl" />-->
      <!--</div>-->
      <!--<div class="title" @click="goToDescription(course.course_id)">-->
      <!--<p>{{ course.name }}</p>-->
      <!--</div>-->
      <!--<div class="remove">-->
      <!--&lt;!&ndash;<font-awesome-icon icon="trash-alt" size="lg"></font-awesome-icon>&ndash;&gt;-->
      <!--<img src="/img/icons/png/trash.png" alt="" />-->
      <!--</div>-->
      <!--<div class="price">-->
      <!--<span class="current">${{ course.price }}</span>-->
      <!--&lt;!&ndash;<span class="discount">$4500</span>&ndash;&gt;-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
    </div>
    <div class="right">
      <!--<div class="get-discount">-->
      <!--<h6 class="heading">Get Discount</h6>-->
      <!--<b-input-group class="mt-3">-->
      <!--<b-form-input placeholder="Coupon"></b-form-input>-->
      <!--<b-input-group-append>-->
      <!--<b-button variant="primary">Go</b-button>-->
      <!--</b-input-group-append>-->
      <!--</b-input-group>-->
      <!--</div>-->
      <div class="cart-summary">
        <h6 class="heading">Total</h6>
        <div class="price">
          <span class="current">₹{{ totalPrice }}</span>
          <!--<span class="discount">$4500</span>-->
        </div>
        <b-btn
          class="checkout-button"
          pill
          size="lg"
          variant="primary"
          @click="checkout"
          >Checkout
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { cartApis } from "../services/cartApis";
import { store } from "../store/store";

export default {
  name: "cart",
  computed: {
    ...mapGetters("cart", ["getCart"]),
    ...mapGetters("user", ["isAuthenticated", "getWishlist"]),
    ...mapGetters("events", ["getRedirectToSubscription", "getShowCartToast"]),
    totalPrice() {
      let total = 0;
      this.getCart.forEach(cartData => {
        total = total + parseInt(cartData.price);
      });
      return total;
    }
  },
  methods: {
    goToHome() {
      this.$router.push({
        path: "/all_courses"
      });
    },
    goToDescription(courseId) {
      this.$router.push({
        path: "/course_description",
        query: { courseId: courseId }
      });
    },
    removeFromCart(courseId) {
      const courseIndex = this.getCart.findIndex(course => {
        return course.course_id === courseId;
      });
      this.getCart.splice(courseIndex, 1);
      store.dispatch("cart/addToCart", this.getCart);
      this.$bvToast.toast(`Removed from Cart`, {
        title: "Cart",
        autoHideDelay: 500,
        appendToast: true
      });
      if (this.isAuthenticated) {
        cartApis.insertCart(this.getCart);
      }
    },
    checkout() {
      if (this.getCart.length !== 0) {
        if (this.isAuthenticated) {
          store.dispatch("events/setIsCheckout", true);
          this.$router.push({
            name: "course_subscription",
            path: "/course_subscription",
            query: {
              isCheckout: true
            }
          });
        } else {
          store.dispatch("events/setRedirectToSubscription", true);
          this.$bvModal.show("modal-1");
        }
      } else {
        this.$bvToast.toast(`Cart is Empty`, {
          title: "Cart",
          autoHideDelay: 500,
          appendToast: true
        });
      }
    }
  },
  mounted() {
    if (this.getShowCartToast) {
      this.$bvToast.toast("Some of your cart items are already subscribed", {
        title: "Cart",
        autoHideDelay: 500,
        appendToast: true
      });
    }
    store.dispatch("events/setShowCartToast", false);
  },
  watch: {
    getRedirectToSubscription() {
      if (this.isAuthenticated) {
        store.dispatch("events/setIsCheckout", true);
        this.$router.push({
          name: "course_subscription",
          path: "/course_subscription",
          query: {
            isCheckout: true
          }
        });
      }
    }
  }
};
</script>

<style scoped></style>
